import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ThankYou from "./main/ThankYou";
import Home from "./main/Home";
import InteractiveHealthcare from "./form/InteractiveHealthcare";
import ThankYouHealthcare from "./form/ThankYouHealthcare";
import InteractiveRealEstate from "./form/InteractiveRealEstate";
import ThankYouRealEstate from "./form/ThankYouRealEstate";
import InteractiveEducation from "./form/InteractiveEducation";
import ThankYouEducation from "./form/ThankYouEducation";

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

function App() {
  return (
    <div className="App relative font-poppins bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/interactive-healthcare" element={<InteractiveHealthcare />} />
          <Route path="/thankyou-healthcare" element={<ThankYouHealthcare />} />
          <Route path="/interactive-realestate" element={<InteractiveRealEstate />} />
          <Route path="/thankyou-realestate" element={<ThankYouRealEstate />} />
          <Route path="/interactive-education" element={<InteractiveEducation />} />
          <Route path="/thankyou-education" element={<ThankYouEducation />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;